import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-common-add-button',
  templateUrl: './common-add-button.component.html',
  styleUrls: ['./common-add-button.component.css']
})
export class CommonAddButtonComponent implements OnInit {
  @Input() buttonData: any;
  @Output() buttonClick = new EventEmitter<any>();
  constructor() { } 

  ngOnInit(): void {
  }

  btnClick() { 
    this.buttonClick.emit(true);
  }

}
